import styled from 'styled-components'

const ModalDonateCoinStyled = styled.div`
  width: 952px;
  position: relative;
  background-color: #4df285;
  clip-path: polygon(0 0, 100% 0, 100% 100%, 40px 100%, 0 calc(100% - 40px));
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1px;
  .donate-coin-modal {
    background-color: ${({ theme }) => theme.color.neutral};
    clip-path: polygon(0 0, 100% 0, 100% 100%, 40px 100%, 0 calc(100% - 40px));
    padding: 8px 30px 15px;
    position: relative;
    min-height: 500px;
    min-width: 950px;

    .close-btn {
      position: absolute;
      top: 10px;
      right: 10px;
      background-color: ${({ theme }) => theme.color.transparent};
      border: none;
      z-index: 1;
    }

    .line__guild--gradiant {
      height: 2px;
      padding: 8px 0;
      img {
        width: 100%;
        height: 2px;
      }
    }

    .title-modal {
      padding-bottom: 10px;
      font-size: 30px;
      font-weight: 600;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      text-transform: uppercase;
    }

    .content-modal {
      color: #dedede;
      .ant-form {
        width: 100%;
      }
      .ant-form-item-explain-error {
        font-size: 16px;
      }
      .balance-container {
        width: 750px;
        margin: auto;
        .balance {
          margin-top: 16px;
          text-align: center;
          .title {
            text-decoration: none;
            color: #4bf296;
            font-size: 20px;
            line-height: 12px;
            text-transform: uppercase;
          }
        }
        .donate {
          margin-top: 30px;
          padding-bottom: 30px;
          display: flex;
          flex-direction: column;
          gap: 24px;
          .donate-user {
            display: flex;
            align-items: center;
            justify-content: center;
            .field-title {
              font-size: 28px;
            }
            .field-value {
              display: flex;
              position: relative;
            }
            .select-currency {
              width: 150px;
              position: absolute;
              right: 0;
            }
            .guild-vault {
              display: flex;
              align-items: center;
              gap: 12px;
              position: absolute;
              right: 0px;
              top: 8px;
              font-weight: 600;
              font-size: 16px;
              width: 150px;
              padding-left: 11px;
              color: #fff;
            }
          }
          .action {
            display: flex;
            justify-content: center;
            align-items: center;
            gap: 80px;
          }
          .text-error {
            color: #ff4d4f;
          }
          .visibility-hidden {
            visibility: hidden;
          }
        }
        .text-new-change {
          padding-top: 20px;
          font-size: 20px;
          color: orange;
          span {
            box-shadow: 0px 0px 2px 2px orange;
            cursor: pointer;
            &:hover {
              filter: drop-shadow(2px 4px 6px black);
            }
          }
        }
        .wallet-icon {
          margin-right: 20px;
        }
        .icon-coin {
          height: 30px;
          text-align: center;
        }
        .wallet {
          display: flex;
          justify-content: space-between;
          gap: 20px;
          margin: 20px 0px;
          .wallet-title {
            color: #4bf296;
            text-align: start;
            font-size: 20px;
          }
          .wallet-item {
            font-size: 20px;
            clip-path: polygon(0 0, 100% 0, 100% 100%, 14px 100%, 0 calc(100% - 14px));
            background-color: rgb(25, 47, 44);
            width: 337px;
            height: 70px;
            display: grid;
            grid-template-columns: 1fr 1fr 2fr;
            color: white;
            align-items: center;
            padding: 0 20px;
            margin: 12px 0px;
            .value-coin {
              text-align: end;
              grid-column: 3 / span 2;
            }
            .name-coin {
              text-align: start;
            }
          }
        }

        .exchange {
          display: flex;
          justify-content: space-between;
          gap: 20px;
          align-items: start;
          margin-left: auto;
          margin-right: auto;
          .exchange-title {
            color: #4bf296;
            text-align: start;
            font-size: 20px;
            text-transform: uppercase;
          }
          .exchange-container {
            position: relative;
            margin-bottom: 20px;
            cursor: pointer;
            .background-line {
              position: absolute;
              top: -12px;
              left: 0px;
              z-index: 1;
            }
            .exchange-item {
              clip-path: polygon(24px 0px, 100% 0px, 100% 100%, 0px 100%, 0px 24px);
              background: linear-gradient(90deg, rgb(105, 209, 130) 0%, rgb(3, 62, 26) 104.33%);
              padding: 2px;
              margin: 12px 0px;
              .exchange-background {
                width: 337px;
                height: 78px;
                display: grid;
                grid-template-columns: auto auto auto;
                color: white;
                align-items: center;
                padding: 0 20px;
                text-align: center;

                clip-path: polygon(24px 0px, 100% 0px, 100% 100%, 0px 100%, 0px 24px);
                background: rgb(25, 29, 44);
                padding: 23px 16px;
              }
            }
          }
          .exchange-container:hover {
            transform: scale(1.1);
            transition-duration: 0.5s;
            filter: drop-shadow(-2px 2px 26px rgb(11 136 235));
          }

          .exchange-note {
            color: #4bf296;
            text-align: start;
            font-size: 18px;
            margin-top: -15px;
          }
        }
      }
    }
  }
`

export default ModalDonateCoinStyled
